module.exports = __webpack_public_path__ + "img/8.d75d86ce.png";